import type { ButtonHTMLAttributes, ReactNode } from "react";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";
type ButtonSize = "sm" | "md" | "icon";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: ReactNode;
};

export function Button({
  className = "",
  variant = "secondary",
  size = "md",
  icon,
  children,
  ...props
}: ButtonProps) {
  const iconOnly = size === "icon";

  return (
    <button
      className={["button", `button-${variant}`, `button-${size}`, className].filter(Boolean).join(" ")}
      type="button"
      {...props}
    >
      {icon}
      {!iconOnly && children ? <span>{children}</span> : null}
    </button>
  );
}
